import * as types from './Types.js';

export function findCargosPaginado(filtro) {
  return ({ fetch }) => ({
    type: types.LIST_CARGOS,
    payload: {
      promise: fetch(`/api/cargos?${filtro}`)
    }
  });
}

export function findFaixas(filtro) {
  return ({ fetch }) => ({
    type: types.LIST_FAIXAS,
    payload: {
      promise: fetch(`/api/cargos/faixas?${filtro}`)
    }
  });
}

export function findCargosNaoPaginado(filtro) {
  return ({ fetch }) => ({
    type: types.FILTRO_CARGOS,
    payload: {
      promise: fetch(`/api/cargos/cargos?${filtro}`)
    }
  });
}

export function findQuadrosSalarial(filtro) {
  return ({ fetch }) => ({
    type: types.FILTRO_QUADROS,
    payload: {
      promise: fetch(`/api/cargos/quadros?${filtro}`)
    }
  });
}

export function findGruposOcupacional(filtro) {
  return ({ fetch }) => ({
    type: types.FILTRO_GRUPOS,
    payload: {
      promise: fetch(`/api/cargos/grupos?${filtro}`)
    }
  });
}

export function findNiveis(filtro) {
  return ({ fetch }) => ({
    type: types.FILTRO_NIVEIS,
    payload: {
      promise: fetch(`/api/cargos/niveis?${filtro}`)
    }
  });
}

export function findFuncoesGratificadasPaginado(filtro) {
  return ({ fetch }) => ({
    type: types.LIST_FUNCOES_GRATIFICADAS,
    payload: {
      promise: fetch(`/api/funcao-gratificada?${filtro}`)
    }
  });
}

export function loadCargos(filtro) {
  return ({ fetch }) => ({
    type: types.LIST_CARGOS_OXY,
    payload: {
      promise: fetch(`/api/cargos/search?${filtro}`)
    }
  });
}

export function loadCargosComNiveis(filtro) {
  return ({ fetch }) => ({
    type: types.LIST_CARGOS_OXY,
    payload: {
      promise: fetch(`/api/cargos/search?${filtro}`).then(response =>
        response.map(cargo => {
          switch (cargo.nivel) {
            case 1: {
              return {
                ...cargo
              };
            }
            case 2: {
              return {
                ...cargo,
                codigo: cargo.planoSalarialEstruturaCodigo,
                descricao: cargo.planoSalarialEstruturaDesc,
                quantidadeVagas: null,
                quantidadeVagasDisponiveis: null
              };
            }
            case 3: {
              return {
                ...cargo,
                codigo: cargo.planoSalarialCodigo,
                descricao: cargo.planoSalarialDescricao,
                quantidadeVagas: null,
                quantidadeVagasDisponiveis: null
              };
            }
            case 4: {
              return {
                ...cargo,
                codigo: null,
                descricao: cargo.matrizSalarialNome,
                quantidadeVagas: null,
                quantidadeVagasDisponiveis: null
              };
            }
          }
        })
      )
    }
  });
}

export function findCargosSelect(filtro) {
  return ({ fetch }) => ({
    type: types.FILTRO_CARGOS,
    payload: {
      promise: fetch(`/api/cargos/busca-cargos?${filtro}`)
    }
  });
}

export function findPlanosSalariais(filtro) {
  return ({ fetch }) => ({
    type: types.FILTRO_PLANOS_SALARIAIS,
    payload: {
      promise: fetch(`/api/cargos/planos-salariais?${filtro}`)
    }
  });
}

export function expand(id, codigo, estrutura, plano, nivel) {
  return {
    type: types.EXPAND_CARGO,
    payload: {
      id,
      codigo,
      estrutura,
      plano,
      nivel
    }
  };
}

export function collapse(id, codigo, estrutura, plano, nivel) {
  return {
    type: types.COLLAPSE_CARGO,
    payload: {
      id,
      codigo,
      estrutura,
      plano,
      nivel
    }
  };
}

export function getMatrizVigente(filtro) {
  return ({ fetch }) => ({
    type: types.LIST_MATRIZ_VIGENTE,
    payload: {
      promise: fetch(`/api/cargos/matriz-vigente?${filtro}`)
    }
  });
}
